// quiz.js
(function() {
  // Add all required styles
  const styles = `
    .button--quiz {
      position: relative;
      opacity: 1;
      transform: translateY(0);
    }

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

  /* Update the modal styles for desktop animation */
  .quiz-modal {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    width: 400px;
    background: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
    z-index: 99999;
    transform: translateY(40px);
    opacity: 0;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
  }

    .quiz-header {
      padding: 1.5rem 1.5rem 1rem;
      border-bottom: 1px solid #E5E5E5;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .quiz-header-content {
      flex: 1;
      padding-right: 1rem;
    }

    .quiz-header h3 {
      margin: 0 0 1rem 0;
      font-size: 1.6rem;
      font-weight: 400;
      line-height: 1.3;
      font-family: 'Playfair Display', serif;
    }

    .quiz-header-subtitle {
      margin: 0;
      color: #666;
      line-height: 1.6;
      font-weight: 400;
      font-family: 'Open Sans', sans-serif;
    }

    .quiz-close {
      background: none;
      border: none;
      cursor: pointer;
      padding: 0.5rem;
      color: #252525;
      flex-shrink: 0;
      transition: opacity 0.2s ease;
    }

    .quiz-close:hover {
      opacity: 0.7;
    }

    .quiz-content {
      padding: 2rem;
      min-height: 200px;
    }

    .quiz-question {
      margin: 0 0 1.5rem;
      font-size: 1.2rem;
      font-weight: 400;
      color: #252525;
      font-family: 'Playfair Display', sans-serif;
    }

    .quiz-option {
      width: 100%;
      padding: 0.875rem 1rem;
      margin-bottom: 0.75rem;
      text-align: left;
      background: none;
      border: 1px solid #E5E5E5;
      cursor: pointer;
      font-family: 'Open Sans', sans-serif;
      font-weight: 400;
      transition: all 0.2s ease-in-out;
      border-radius: 4px;
      position: relative;
    }

    .quiz-option:hover {
      background: #F7F7F7;
      border-color: #252525;
    }

    .quiz-option:active {
      transform: scale(0.98);
    }

    .quiz-size-input {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      margin: 2rem 0;
    }

    .quiz-size-btn {
      background: none;
      border: 1px solid #E5E5E5;
      width: 40px;
      height: 40px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s ease;
      border-radius: 4px;
    }

    .quiz-size-btn:hover {
      background: #F7F7F7;
      border-color: #252525;
    }

    .quiz-size-btn:active {
      transform: scale(0.95);
    }

    .quiz-size-number {
      width: 80px;
      height: 40px;
      text-align: center;
      border: 1px solid #E5E5E5;
      font-size: 16px;
      -moz-appearance: textfield;
      border-radius: 4px;
      transition: border-color 0.2s ease;
    }

    .quiz-size-number:focus {
      outline: none;
      border-color: #252525;
    }

    .quiz-size-number::-webkit-outer-spin-button,
    .quiz-size-number::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    .quiz-result {
      text-align: center;
    }

    .quiz-result h4 {
      margin: 0 0 1rem;
      font-size: 1.8rem;
      font-weight: 500;
      font-family: 'Playfair Display', serif;
      color: #252525;
    }

    .quiz-result > p {
      font-family: 'Open Sans', sans-serif;
      color: #666;
      margin-bottom: 2rem;
    }

    .quiz-result-product {
      margin: 2rem 0;
      padding: 2.5rem 2rem;
      background: #F7F7F7;
      border-radius: 4px;
    }

    .quiz-result-product h5 {
      margin: 0 0 0.25rem;
      font-size: 1.8rem;
      font-weight: 500;
      font-family: 'Playfair Display', serif;
      color: #252525;
    }

    .quiz-result-product p {
      margin: 0;
      font-size: 1.2rem;
      font-family: 'Open Sans', sans-serif;
      color: #252525;
      font-weight: 500;
    }

    .quiz-submit {
      width: 100%;
      background-color: #252525;
      color: #FFFFFF;
      border: none;
      cursor: pointer;
      transition: opacity 0.2s ease-in-out;
      text-decoration: none;
      display: inline-block;
      text-align: center;
      border-radius: 0px;
    }

    .quiz-submit:hover {
      opacity: 0.85;
    }

    .quiz-progress {
      padding: 0 1.5rem 1.5rem;
    }

    .quiz-progress-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;
      font-size: 12px;
      color: #999;
      font-family: 'Open Sans', sans-serif;
    }

    .quiz-progress-steps {
      font-weight: 500;
    }

    .quiz-progress-bar {
      width: 100%;
      height: 4px;
      background: #E5E5E5;
      border-radius: 2px;
      overflow: hidden;
    }

    .quiz-progress-indicator {
      height: 100%;
      background: #252525;
      transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      border-radius: 2px;
    }

    .quiz-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 99998;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    .quiz-modal.is-active {
      transform: translateY(0);
      opacity: 1;
    }

    .quiz-content-wrapper {
      opacity: 1;
      transform: translateY(0);
      transition: opacity 0.2s ease, transform 0.2s ease;
    }

    .quiz-content-wrapper.transitioning {
      opacity: 0;
      transform: translateY(-10px);
    }

    @media (max-width: 768px) {
      .quiz-modal {
        width: 100%;
        right: 0;
        bottom: 0;
        border-radius: 12px 12px 0 0;
        transform: translateY(100%);
        max-height: 90vh;
        overflow-y: auto;
      }

      .quiz-modal.is-active {
        transform: translateY(0);
      }
    
      .quiz-content {
        padding: 1.5rem;
      }
    
      .quiz-size-input {
        gap: 0.75rem;
      }
    
      .quiz-size-btn {
        width: 36px;
        height: 36px;
      }

      .quiz-header {
        padding: 1.25rem 1.25rem 0.75rem;
      }

      .quiz-header h3 {
        font-size: 1.6rem;
      }

      .quiz-header-subtitle {
        font-size: 12px;
      }
    }`;

  // Add the styles to the document
  const styleSheet = document.createElement("style");
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);

  class FitQuiz {
    constructor() {
      this.step = 0;
      this.answers = {
        activity: null,
        chafing: null,
        waistSize: 29
      };
      this.isOpen = false;
      this.totalSteps = 3;
      this.init();
    }

    init() {
      this.insertQuizButton();
      this.addFindYourSizeButton();
    
      // Add a CSS rule for the recommended size styling
      const style = document.createElement('style');
      style.textContent = `
        .block-swatch--recommended {
          padding: 2px;
          border-radius: 1px;
        }
        .block-swatch--recommended label {
          margin: 0 !important;
        }
        .size-recommendation {
          background: #ededed;
          padding: 12px 15px;
          margin-top: 15px;
          font-size: 14px;
          display: block;
        }
        .size-recommendation strong {
          font-weight: 500;
        }
      `;
      document.head.appendChild(style);
      
      // Listen for product:updated events to reapply on toggle
      document.addEventListener('product:updated', () => {
        setTimeout(() => {
          this.addFindYourSizeButton();
          this.applySizeRecommendation();
        }, 500);
      });
    }

    insertQuizButton() {
      // Find the first button in the hero section
      const primaryButton = document.querySelector('.slideshow__slide .button--primary');
      if (primaryButton) {
        const buttonWrapper = primaryButton.closest('.button-wrapper, .button-group__wrapper');
        
        if (buttonWrapper) {
          // If it's not already a button group, convert it to one
          if (buttonWrapper.classList.contains('button-wrapper')) {
            const newButtonGroup = document.createElement('div');
            newButtonGroup.className = 'button-group';
            newButtonGroup.innerHTML = '<div class="button-group__wrapper"></div>';
            buttonWrapper.parentNode.replaceChild(newButtonGroup, buttonWrapper);
            newButtonGroup.querySelector('.button-group__wrapper').appendChild(primaryButton);
            
            // Add our new quiz button
            const quizButton = document.createElement('button');
            quizButton.className = 'button button--secondary button--quiz';
            quizButton.textContent = 'Find Your Perfect Pair';
            quizButton.addEventListener('click', () => this.openQuiz());
            newButtonGroup.querySelector('.button-group__wrapper').appendChild(quizButton);
          } else {
            // It's already a button group, just add our button
            const quizButton = document.createElement('button');
            quizButton.className = 'button button--secondary button--quiz';
            quizButton.textContent = 'Find Your Perfect Pair';
            quizButton.addEventListener('click', () => this.openQuiz());
            buttonWrapper.appendChild(quizButton);
          }
        }
      }
    }

    addFindYourSizeButton() {
      // Skip completely on product pages since button is hardcoded
      if (window.location.pathname.includes('/products/')) {
        return;
      }
    }

    createQuizModal() {
      const modal = document.createElement('div');
      modal.className = 'quiz-modal';
      
      // Calculate progress percentage
      const progressPercent = (this.step / this.totalSteps) * 100;
      const isResultPage = this.step >= this.totalSteps;
      
      modal.innerHTML = `
        <div class="quiz-header">
          <div class="quiz-header-content">
            <h3 class="heading h4">Find your perfect pair</h3>
            ${!isResultPage ? '<p class="quiz-header-subtitle">Answer 3 quick questions and we\'ll recommend your perfect pair. No signup required.</p>' : ''}
          </div>
          <button class="quiz-close" aria-label="Close quiz">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div class="quiz-content">
          <div class="quiz-content-wrapper">
            ${this.getStepContent()}
          </div>
        </div>
        ${this.step < this.totalSteps ? `
          <div class="quiz-progress">
            <div class="quiz-progress-header">
              <span class="quiz-progress-steps">Question ${this.step + 1} of ${this.totalSteps}</span>
              <span class="quiz-progress-percent">${Math.round(progressPercent)}%</span>
            </div>
            <div class="quiz-progress-bar">
              <div class="quiz-progress-indicator" style="width: ${progressPercent}%"></div>
            </div>
          </div>
        ` : ''}
      `;

      modal.querySelector('.quiz-close').addEventListener('click', () => this.closeQuiz());
      this.attachStepListeners(modal);

      return modal;
    }

    getStepContent() {
      switch(this.step) {
        case 0:
          return `
            <div>
              <p class="quiz-question">Are you typically active or sedentary during the day?</p>
              <button class="quiz-option" data-value="active">Active</button>
              <button class="quiz-option" data-value="sedentary">Sedentary</button>
            </div>
          `;
        case 1:
          return `
            <div>
              <p class="quiz-question">Do you experience chafing?</p>
              <button class="quiz-option" data-value="yes">Yes</button>
              <button class="quiz-option" data-value="no">No</button>
            </div>
          `;
        case 2:
          return `
            <div>
              <p class="quiz-question">What is your pants size?</p>
              <div class="quiz-size-input">
                <button class="quiz-size-btn minus" type="button" aria-label="Decrease size">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                </button>
                <input type="number" min="29" max="47" value="${this.answers.waistSize}" class="quiz-size-number" aria-label="Pants size">
                <button class="quiz-size-btn plus" type="button" aria-label="Increase size">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                </button>
              </div>
              <button class="quiz-submit button button--secondary">See Results</button>
            </div>
          `;
        case 3:
          const recommendation = this.calculateRecommendation();
          return `
            <div class="quiz-result">
              <h4>Your Perfect Pair</h4>
              <p>Based on your answers, we recommend:</p>
              <div class="quiz-result-product">
                <h5>${recommendation.productType === 'boxer-briefs' ? 'Boxer Briefs' : 'Trunks'}</h5>
                <p>Size: ${recommendation.size}</p>
              </div>
              <a href="/products/${recommendation.productType}" class="quiz-submit button button--secondary">Shop Now</a>
            </div>
          `;
        default:
          return '';
      }
    }

    attachStepListeners(modal) {
      const content = modal.querySelector('.quiz-content');
      
      if (this.step === 0 || this.step === 1) {
        content.querySelectorAll('.quiz-option').forEach(button => {
          button.addEventListener('click', (e) => {
            const value = e.target.dataset.value;
            if (this.step === 0) {
              this.answers.activity = value;
              this.trackEvent('quiz_activity', value);
            } else {
              this.answers.chafing = value;
              this.trackEvent('quiz_chafing', value);
            }
            this.nextStep();
          });
        });
      } else if (this.step === 2) {
        const input = content.querySelector('.quiz-size-number');
        const minusBtn = content.querySelector('.quiz-size-btn.minus');
        const plusBtn = content.querySelector('.quiz-size-btn.plus');
        
        const updateSize = (value) => {
          value = Math.min(47, Math.max(29, value));
          this.answers.waistSize = value;
          input.value = value;
        };
        
        input.addEventListener('change', (e) => {
          updateSize(parseInt(e.target.value) || 29);
        });
        
        minusBtn.addEventListener('click', () => {
          updateSize(parseInt(input.value) - 1);
        });
        
        plusBtn.addEventListener('click', () => {
          updateSize(parseInt(input.value) + 1);
        });

        content.querySelector('.quiz-submit').addEventListener('click', () => {
          this.complete();
        });
      } else if (this.step === 3) {
        const shopNowBtn = content.querySelector('.quiz-submit');
        if (shopNowBtn) {
          shopNowBtn.addEventListener('click', () => {
            this.trackEvent('quiz_shop_now', this.calculateRecommendation().productType);
          });
        }
      }
    }

    calculateRecommendation() {
      const { activity, chafing, waistSize } = this.answers;
      
      let productType = 'trunks';
      if (activity === 'active' || chafing === 'yes') {
        productType = 'boxer-briefs';
      }
      
      let size = 'Small';
      let sizeCode = 'S';
      if (waistSize >= 31 && waistSize <= 34) {
        size = 'Medium';
        sizeCode = 'M';
      } else if (waistSize >= 35 && waistSize <= 38) {
        size = 'Large';
        sizeCode = 'L';
      } else if (waistSize >= 39 && waistSize <= 43) {
        size = 'Extra Large';
        sizeCode = 'XL';
      } else if (waistSize >= 44) {
        size = 'Double Extra Large';
        sizeCode = 'XXL';
      }
      
      return { productType, size, sizeCode };
    }

    nextStep() {
      // Add transition effect
      const contentWrapper = document.querySelector('.quiz-content-wrapper');
      if (contentWrapper) {
        contentWrapper.classList.add('transitioning');
        
        setTimeout(() => {
          this.step++;
          this.updateQuiz();
        }, 200);
      } else {
        this.step++;
        this.updateQuiz();
      }
    }

    complete() {
      const recommendation = this.calculateRecommendation();
      localStorage.setItem('underwearFitRecommendation', JSON.stringify(recommendation));
      sessionStorage.setItem('justCompletedQuiz', 'true');

      this.trackEvent('quiz_complete', `${recommendation.productType}:${recommendation.size}`);

      this.step = 3;
      this.updateQuiz();
    }

    updateQuiz() {
      const oldModal = document.querySelector('.quiz-modal');
      const newModal = this.createQuizModal();
      
      // Preserve the is-active class if it exists
      if (oldModal.classList.contains('is-active')) {
        newModal.classList.add('is-active');
      }
      
      oldModal.parentNode.replaceChild(newModal, oldModal);
    }

    openQuiz() {
      // If modal already exists, don't create a new one
      const existingModal = document.querySelector('.quiz-modal');
      if (existingModal) {
        return;
      }
      
      // Create overlay for outside clicks
      const overlay = document.createElement('div');
      overlay.className = 'quiz-overlay';
      
      // Handle clicking outside to close
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          this.closeQuiz();
        }
      });
      
      document.body.appendChild(overlay);
      
      // Create and add the modal
      const modal = this.createQuizModal();
      document.body.appendChild(modal);
      
      // Trigger animations with a slight delay
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          overlay.style.opacity = '1';
          modal.classList.add('is-active');
        });
      });
      
      this.isOpen = true;
      this.trackEvent('quiz_open', 'Quiz opened');
    }
    
    closeQuiz() {
      const modal = document.querySelector('.quiz-modal');
      const overlay = document.querySelector('.quiz-overlay');
      
      if (modal) {
        modal.classList.remove('is-active');
        
        if (overlay) {
          overlay.style.opacity = '0';
        }
        
        // Wait for animations to complete before removing
        setTimeout(() => {
          if (modal && modal.parentNode) {
            modal.remove();
          }
          if (overlay && overlay.parentNode) {
            overlay.remove();
          }
        }, 400);
      }
      
      this.isOpen = false;
      if (this.step < 3) {
        this.trackEvent('quiz_abandoned', `Step ${this.step + 1}`);
      }
    }

    applySizeRecommendation() {
      const recommendation = localStorage.getItem('underwearFitRecommendation');
      if (!recommendation) {
        return;
      }
      
      try {
        const { size } = JSON.parse(recommendation);
        
        // Add recommended border
        const sizeButtons = document.querySelectorAll('.block-swatch');
        let recommendedFound = false;
        
        sizeButtons.forEach(swatch => {
          const input = swatch.querySelector('input[type="radio"]');
          if (input && input.value === size) {
            swatch.classList.add('block-swatch--recommended');
            recommendedFound = true;
          }
        });
        
        // Add text below size selector
        if (recommendedFound) {
          this.trackEvent('recommendation_shown', size);
          const sizeList = document.querySelector('.block-swatch-list');
          if (sizeList) {
            // Remove any existing
            const existingRec = document.querySelector('.size-recommendation');
            if (existingRec) {
              existingRec.remove();
            }
            
            const sizeText = {
              'S': 'Small (28-30")',
              'M': 'Medium (31-34")',
              'L': 'Large (35-38")',
              'XL': 'Extra Large (39-43")',
              'XXL': 'Double Extra Large (44-47")'
            }[size] || size;
            
            const recommendationDiv = document.createElement('div');
            recommendationDiv.className = 'size-recommendation';
            recommendationDiv.innerHTML = `Your recommended size is: <strong>${sizeText}</strong>`;
            
            sizeList.insertAdjacentElement('afterend', recommendationDiv);
          }
        }
      } catch (error) {
        console.error('Error applying size recommendation:', error);
      }
    }

    trackEvent(action, label = null, value = null) {
      // gtag tracking
      if (typeof gtag === 'function') {
        const eventData = {
          event_category: 'Size Quiz'
        };
        
        if (label) {
          eventData.event_label = label;
        }
        
        if (value) {
          eventData.value = value;
        }
        
        gtag('event', action, eventData);
      }
    }
  }

  // Initialize the quiz when DOM is ready
  function initQuiz() {
    window.fitQuiz = new FitQuiz();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuiz);
  } else {
    initQuiz();
  }
})();